<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/"
          :class="getRoute() === '' ? 'active' : ''"
          :navText="'Dashboard'"
        >
          <template #icon>
            <i class="ni ni-shop text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <button
          type="button"
          class="nav-link btn"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
          style="box-shadow: none"
        >
          <div
            class="
              icon icon-shape icon-sm
              text-center
              d-flex
              align-items-center
              justify-content-center
              w-100
            "
          >
            <i class="ni ni-align-left-2 text-success text-sm opacity-10"></i>
            <span style="padding-left: 1rem; font-weight: 500; color: #67748e"
              >Perangkat</span
            >
          </div>
        </button>
        <div class="collapse" id="collapseExample">
          <sidenav-item
            url="/perangkat/internal"
            :class="[getRoute() === 'internal' ? 'active' : '', 'ms-4']"
            :navText="'Internal'"
          >
          </sidenav-item>
          <sidenav-item
            url="/perangkat/postel"
            :class="[getRoute() === 'postel' ? 'active' : '', 'ms-4']"
            :navText="'Postel'"
          >
          </sidenav-item>
          <sidenav-item
            url="/perangkat/download-postel"
            :class="[getRoute() === 'download-postel' ? 'active' : '', 'ms-4']"
            :navText="'Kominfo'"
          >
          </sidenav-item>
        </div>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/gudang"
          :class="getRoute() === 'gudang' ? 'active' : ''"
          :navText="'Gudang'"
        >
          <template v-slot:icon>
            <i class="ni ni-shop text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <button
          class="nav-link btn"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExample2"
          aria-expanded="false"
          aria-controls="collapseExample2"
          style="box-shadow: none"
        >
          <div
            class="
              icon icon-shape icon-sm
              text-center
              d-flex
              align-items-center
              justify-content-center
              w-100
            "
          >
            <i class="fa fa-history text-warning text-sm opacity-10"></i>
            <span style="padding-left: 1rem; font-weight: 500; color: #67748e"
              >Riwayat</span
            >
          </div>
        </button>
        <div class="collapse" id="collapseExample2">
          <sidenav-item
            url="/riwayat/upload"
            :class="[getRoute() === 'upload' ? 'active' : '', 'ms-4']"
            :navText="'Upload'"
          >
          </sidenav-item>
          <sidenav-item
            url="/riwayat/unit"
            :class="[getRoute() === 'unit' ? 'active' : '', 'ms-4']"
            :navText="'Unit'"
          >
          </sidenav-item>
        </div>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/laporan"
          :class="getRoute() === 'laporan' ? 'active' : ''"
          :navText="'Laporan'"
        >
          <template v-slot:icon>
            <i class="fa fa-book text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
    SidenavCard,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[2] ? routeArr[2] : routeArr[1];
    },
  },
};
</script>
